import { useEffect } from "react";

interface SeoOptions {
  title: string;
  description: string;
  keywords?: string;
  jsonLd?: object;
}

export default function useSeo({ title, description, keywords, jsonLd }: SeoOptions) {
  useEffect(() => {
    document.title = title;
    let desc: HTMLMetaElement | null = document.querySelector('meta[name="description"]');
    if (!desc) {
      desc = document.createElement("meta");
      desc.setAttribute("name", "description");
      document.head.appendChild(desc);
    }
    desc.setAttribute("content", description);

    if (keywords) {
      let kw: HTMLMetaElement | null = document.querySelector('meta[name="keywords"]');
      if (!kw) {
        kw = document.createElement("meta");
        kw.setAttribute("name", "keywords");
        document.head.appendChild(kw);
      }
      kw.setAttribute("content", keywords);
    }

    let script = document.querySelector("script[data-seo-jsonld]") as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement("script");
      script.setAttribute("type", "application/ld+json");
      script.setAttribute("data-seo-jsonld", "");
      document.head.appendChild(script);
    }
    script.textContent = jsonLd ? JSON.stringify(jsonLd) : "";

    return () => {
      document.title = "羞羞动漫漫画恋爱后宫题材专区";
    };
  }, [title, description, keywords, jsonLd]);
}